<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 5C16.1895 5 5 16.1895 5 30C5 43.8105 16.1895 55 30 55C43.8105 55 55 43.8105 55 30C55 16.1895 43.8105 5 30 5ZM38.0645 21.9355C39.8488 21.9355 41.2903 23.377 41.2903 25.1613C41.2903 26.9456 39.8488 28.3871 38.0645 28.3871C36.2802 28.3871 34.8387 26.9456 34.8387 25.1613C34.8387 23.377 36.2802 21.9355 38.0645 21.9355ZM20.3226 46.129C17.6512 46.129 15.4839 44.0121 15.4839 41.3911C15.4839 39.375 18.3569 35.3024 19.6774 33.5484C20 33.1149 20.6452 33.1149 20.9677 33.5484C22.2883 35.3024 25.1613 39.375 25.1613 41.3911C25.1613 44.0121 22.994 46.129 20.3226 46.129ZM21.9355 28.3871C20.1512 28.3871 18.7097 26.9456 18.7097 25.1613C18.7097 23.377 20.1512 21.9355 21.9355 21.9355C23.7198 21.9355 25.1613 23.377 25.1613 25.1613C25.1613 26.9456 23.7198 28.3871 21.9355 28.3871ZM39.0927 43.9315C36.8347 41.2298 33.5181 39.6774 30 39.6774C27.8629 39.6774 27.8629 36.4516 30 36.4516C34.4758 36.4516 38.6996 38.4274 41.5625 41.875C42.9536 43.5282 40.4335 45.5544 39.0927 43.9315Z"
      fill="var(--systemError)"
    />
  </svg>
</template>
